import * as Yup from 'yup';

const Message = {
  REQUIRED: 'Обязательное поле',
  POSITIVE: 'Значение должно быть положительным',
  NON_NEGATIVE: 'Значение не может быть отрицательным',
};

export const warehouseIncomeSchema = Yup.object({
  warehouseId: Yup.string().required(Message.REQUIRED).nullable(),
  documentDateTime: Yup.date().required(Message.REQUIRED).nullable(),
  type: Yup.number().required(Message.REQUIRED).nullable(),
  supplierId: Yup.string().nullable(),
  comment: Yup.string().nullable(),
  items: Yup.array()
    .of(
      Yup.object({
        nomenclatureId: Yup.string().required(Message.REQUIRED).nullable(),
        quantity: Yup.number()
          .required(Message.REQUIRED)
          .positive(Message.POSITIVE)
          .nullable(),
        purchasePrice: Yup.number()
          .required(Message.REQUIRED)
          .min(0, Message.NON_NEGATIVE)
          .nullable(),
        batchNumber: Yup.string().nullable(),
        comment: Yup.string().nullable(),
      })
    )
    .min(1, 'Добавьте хотя бы одну позицию')
    .required(Message.REQUIRED),
});
